import { useEffect, useRef } from "react";

import SearchControl from "@modules/Projects/pages/SearchControl";
import {
  MapContainer,
  Marker,
  TileLayer,
  LayersControl,
  useMap,
  useMapEvents,
} from "react-leaflet";
import { parentTreeIcon } from "@helper/marker";
import { useTranslation } from "react-i18next";

function ChooseLocation({ showMap, setPosition, setShowMap, mapPosition, zoom, readOnly = false }) {
  const { t } = useTranslation();
  const mapInteractionProps = readOnly ? {} : {};
  return (
    <div>
      {showMap && (
        <MapContainer
          center={[48.130458, 11.6188528]}
          zoom={zoom ? zoom : 7}
          zoomControl={true}
          style={{ height: "250px", marginTop: "10px" }}
          {...mapInteractionProps}
        >
          <LayersControl position="topright">
            <LayersControl.BaseLayer checked name="Street Map">
              <TileLayer
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
              />
            </LayersControl.BaseLayer>
            <LayersControl.BaseLayer name="Satellite">
              <TileLayer
                url="https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}"
                attribution="Tiles &copy; Esri &mdash; Source: Esri, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community"
              />
            </LayersControl.BaseLayer>
          </LayersControl>

          {!readOnly && (
            <SearchControl
              showMarker={true}
              showPopup={true}
              popupFormat={(result) => result.result.label}
              maxMarkers={1}
              retainZoomLevel={false}
              animateZoom={true}
              autoClose={false}
              searchLabel={t("search_address")}
              keepResult={true}
              position="topleft"
            />
          )}

          <LocationMarker
            setPosition={setPosition}
            setShowMap={setShowMap}
            mapPosition={mapPosition}
            readOnly={readOnly}
          />
        </MapContainer>
      )}
    </div>
  );
}

export default ChooseLocation;

function LocationMarker({ setPosition, mapPosition, readOnly }) {
  const defaultPosition = { lat: "48.130458", lng: "11.6188528" }; // treesense office
  const map = useMap();
  const lastAppliedRef = useRef(null);
  useEffect(() => {
    if (mapPosition?.latlng && mapPosition.latlng !== null) {
      const next = mapPosition.latlng;
      const last = lastAppliedRef.current;
      if (
        last &&
        Math.abs(last.lat - next.lat) < 0.00001 &&
        Math.abs(last.lng - next.lng) < 0.00001
      ) {
        return;
      }
      if (next.lat != "") {
        const center = map.getCenter();
        if (
          Math.abs(center.lat - next.lat) < 0.00001 &&
          Math.abs(center.lng - next.lng) < 0.00001
        ) {
          lastAppliedRef.current = next;
          return;
        }
        map.setView(next, map.getZoom()); // retain current zoom
        lastAppliedRef.current = next;
      } else {
        map.setView(defaultPosition, 3); // default zoom to show europe only
      }
    }
  }, [mapPosition?.latlng?.lat, mapPosition?.latlng?.lng, map]);

  useMapEvents({
    click(e) {
      if (readOnly) return;
      setPosition(e.latlng);
    },
  });
  return (
    <>
      {mapPosition ? (
        <Marker
          icon={parentTreeIcon(0)}
          position={mapPosition.latlng?.lat ? mapPosition.latlng : defaultPosition}
        />
      ) : (
        <></>
      )}
    </>
  );
}
